import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/shawn-rain-qm63uPRGKIs-unsplash.jpeg";

function DigitaleKommunikasjonstrender() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>
          {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.title")}
        </title>
        <meta
          name="description"
          content={i18next.t(
            "pages.articles.list.digitaleKommunikasjonstrender.description"
          )}
        />
        <link rel="canonical" href="https://xperconsulting.no/artikler/digitale-kommunikasjonstrender-2025" />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left">
          <img
            className="w-full h-full object-cover"
            src={article_img}
            alt={i18next.t(
              "pages.articles.list.digitaleKommunikasjonstrender.imageAlt"
            )}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            
            <p className="mb-8 font-semibold">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.intro.subtitle"
              )}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.accessibility.title"
              )}
            </h2>
            <p className="mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.accessibility.content"
              )}
            </p>
            <p className="mb-8">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.accessibility.conclusion"
              )}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.onDemand.title"
              )}
            </h2>
            <p className="mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.onDemand.content"
              )}
            </p>
            <p className="mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.onDemand.conclusion"
              )}
            </p>
            <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className=" underline hover:text-contrast-ink">{i18next.t("pages.articles.list.digitaleKommunikasjonstrender.sections.onDemand.readMore")}</a>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.personalized.title"
              )}
            </h2>
            <p className="mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.personalized.content"
              )}
              <a href="/ccm" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.sections.personalized.link")}
              </a>
              {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.sections.personalized.content2")}
            </p>
            <p className="mb-8">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.personalized.conclusion"
              )}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.automation.title"
              )}
            </h2>
            <p className="mb-8">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.automation.content"
              )}
            </p>

            <h2 className="text-4xl font-bold mt-12 mb-4">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.future.title"
              )}
            </h2>
            <p className="mb-8">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.future.content"
              )}
            </p>

            <p className="text-lg font-semibold">
              {i18next.t(
                "pages.articles.list.digitaleKommunikasjonstrender.sections.cta.content"
              )}
              <a href="/skjema/kontakt-oss" className="text-lg font-semibold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.sections.cta.link")}
              </a>
              {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.sections.cta.content2")}
            </p>
            
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default DigitaleKommunikasjonstrender;
